export const ACCESS_FORBIDDEN_CODE = 403
export const UNAUTHORIZED_CODE = 401
export const UNPROCESSIBLE_CODE = 422
export const INTERNAL_SERVER_ERROR_CODE = 500
